import React, { useEffect } from 'react'
import { Link, useForm, usePage } from '@inertiajs/react'

import { toast } from 'react-toastify'

import Layout from '@/Shared/Layout'

import Form from './Shared/Form'

const Create = () => {
    const { hospitals, type } = usePage().props

    const { data, setData, errors, post, processing } = useForm({
        hospital_id: typeof hospitals === 'object' ? null : hospitals,
        firm: 'PMU',
        brooms: '',
        wiper: '',
        normal_waste_21_bag: '',
        normal_waste_30_bag: '',
        normal_waste_39_bag: '',
        furniture_dusters: '',
        disinfectant: '',
        hand_wash_liquid: '',
        air_freshener: '',
        mop_pads: '',
        liquid_toilet_cleaner: '',
        floor_mops_standard: '',
        hand_wash_dispenser: '',
        floor_cleaning_towels: '',
        disposable_bed_sheets: '',
        air_freshener_2: '',
        air_freshener_3: '',
        arrived_date: '',
        type
    })

    useEffect(() => {
        Object.values(errors).map(error => {
            toast.error(error)
        })
    }, [errors])

    function handleSubmit(e) {
        e.preventDefault()
        post(route('consumable.store'))
    }

    return (
        <div>
            <h1 className="mb-8 text-3xl font-bold">
                <Link
                    onClick={() => history.back()}
                    className="text-indigo-600 hover:text-indigo-700"
                >
                    Consumable
                </Link>
                <span className="font-medium text-indigo-600"> /</span> Create
            </h1>

            <div className="max-w-3xl overflow-hidden rounded bg-white p-8 shadow">
                <h1 className="text-2xl font-semibold">Consumable Form</h1>

                <Form
                    hospitals={hospitals}
                    handleSubmit={handleSubmit}
                    data={data}
                    errors={errors}
                    setData={setData}
                    processing={processing}
                />
            </div>
        </div>
    )
}

Create.layout = page => <Layout title="Create Organization" children={page} />

export default Create
